import {memo, useMemo} from 'react';

import {useTheme} from '@/src/hooks/useTheme';
import PartnersListItem from '@/src/signUp/layoutSingUp/componetns/PartnersListItem';

import css from '../styles/PartnersList.module.css';

const PARTNERS_DARK = [
  '/images/signup/partners/partner3.png',
  '/images/signup/partners/partner2.png',
  '/images/signup/partners/partner1.png',
];

const PARTNERS_LIGHT = [
  '/images/signup/partners/light/partner3.png',
  '/images/signup/partners/light/partner2.svg',
  '/images/signup/partners/light/partner1.svg',
];

const PartnersList = () => {
  const {isDarkMode} = useTheme();
  const partners = isDarkMode ? PARTNERS_DARK : PARTNERS_LIGHT;

  const partnersJSX = useMemo(
    () => partners.map((src) => <PartnersListItem key={src} src={src} />),
    [partners]
  );

  return <div className={css.images}>{partnersJSX}</div>;
};

export default memo(PartnersList);
